import { render, staticRenderFns } from "./ListNotification.vue?vue&type=template&id=fd4aaf9c&scoped=true&"
import script from "./ListNotification.vue?vue&type=script&lang=js&"
export * from "./ListNotification.vue?vue&type=script&lang=js&"
import style0 from "./ListNotification.vue?vue&type=style&index=0&id=fd4aaf9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4aaf9c",
  null
  
)

export default component.exports